export default "__VITE_ASSET__CO4Io8nZ__"